<template>
  <admin-layout title="Templates" menu="Templates">
    <div class="row">
      <div class="col-lg-2 col-xs-12">
        <div class="form-group color-dark-purple mb-0">
          <h3>TEMPLATES</h3>
        </div>
      </div>
      <div class="col-lg-3 p-0 m-0">
        <button @click="saveTemplate" class="btn-new-job full">
          CRIAR TEMPLATE
        </button>
      </div>
      <div class="col-lg-7"></div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-6">
            <input
              type="text"
              v-model="templateName"
              class="form-control"
              placeholder="INSIRA O NOME DO TEMPLATE"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-3"></div>
      <div class="col-lg-3">
        <div
          class="form-group mb-0 has-search d-flex justify-content-end"
          style="margin-left: -3px"
        >
          <div>
            <span
              class="color-black fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
            ></span>
          </div>
          <input
            type="text"
            v-model="search"
            v-on:keyup.enter="searchTemplates"
            class="form-control no_border pl-5"
            style="padding: 0px"
          />
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="row">
              <div class="col-lg-12">
                <table class="table_jovool">
                  <thead class="headerTable">
                    <tr>
                      <td>
                        NOME DO TEMPLATE
                        <OrderTable field="name" entity="Template" />
                      </td>
                      <td class="center">
                        DATA DE CRIAÇÃO
                        <OrderTable
                          field="created_at"
                          entity="Template"
                          pre_order="desc"
                        />
                      </td>
                      <td class="center">
                        RECRUTADOR(A)
                        <OrderTable entity="Template" field="recruiter_name" />
                      </td>
                      <td class="center">EDITAR</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="template in templates" :key="template.id">
                      <td>
                        <inertia-link
                          :href="`/recruiters/templates/${template.id}/edit`"
                        >
                          <b class="color-grey-primary">{{ template.name }}</b>
                        </inertia-link>
                      </td>
                      <td class="center color-grey">
                        {{ template.created_at | moment("D/MM/Y") }}
                      </td>
                      <td class="center color-grey">
                        {{ template.recruiter.name }}
                      </td>
                      <td class="center">
                        <inertia-link
                          :href="`/recruiters/templates/${template.id}/edit`"
                          class="pt-4 pointer color-primary"
                        >
                          <i class="fas f25 color-primary fa-file-alt"></i>
                        </inertia-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import OrderTable from "components/OrderTable.vue";
import axios from "axios";
export default {
  components: { OrderTable },
  data() {
    return {
      search: "",
      order: "",
      field: "",
      templateName: "",
      templates: [],
    };
  },
  mounted() {
    eventBus.$on("orderColumnTemplate", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchTemplates();
    });
    this.searchTemplates();
  },
  methods: {
    searchTemplates() {
      let params = {};

      params["search"] = "*";
      if (this.search !== "") params["search"] = this.search;

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      } else {
        params["order"] = {};
        params["order"]["created_at"] = "desc";
      }

      axios
        .get("/recruiters/templates/search", { params: params })
        .then((response) => {
          this.templates = response.data.templates;
        });
    },
    saveTemplate() {
      if (this.templateName.length < 4) {
        this.$toast.error(
          "o NOME DO TEMPLATE DEVE TER NO MÍNIMO 4 CARACTERES."
        );
        return;
      }
      axios
        .post("/recruiters/templates", {
          templates: {
            name: this.templateName,
          },
        })
        .then((response) => {
          if (response.data.already_exits) {
            this.$toast.error("ESSE TEMPLATE JÁ FOI CRIADO.");
            return;
          }
          let id = response.data.template.id;
          this.$inertia.visit(`/recruiters/templates/${id}/edit`);
        });
    },
  },
};
</script>